import { R } from './fancybox.esm-BD9aNYFB.js';

/**
 * Quickshop
 */
if (!customElements.get('quickshop-wrapper')) {
  class QuickShopWrapper extends HTMLElement {
    constructor() {
      super();

      this.options = {
        popup: true,
        submitSingleVariant: true,
      };

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }
    }

    connectedCallback() {
      this.backdrop = this.backdrop || this.querySelector('[data-quickshop-backdrop]');

      this.backdrop.addEventListener('click', () => {
        this.closeQuickshop();
      });

      // Listen for the quickshop-toggle event
      this.addEventListener('quickshop-toggle', () => {
        let open = !this.classList.contains('quick-shop--is-open');

        // If the quickshop only has one variant, Add it to the cart
        if (this.options.submitSingleVariant) {
          this.variantOptions = this.variantOptions || this.querySelectorAll('[data-option-group]');
          if (!this.variantOptions.length) {
            this.submit = this.submit || this.querySelector('[type="submit"]');
            this.submit.click();
            return false;
          }
        }

        if (open) {
          this.openQuickshop();
        } else {
          this.closeQuickshop();
        }
      });

      // On mouseleave, close the inline quickshop
      if (!this.options.popup) {
        this.addEventListener('mouseleave', () => {
          this.closeQuickshop();
        });
      }

      // Close the popup quickshop on cart update
      const productForm = this.querySelector('product-form');
      if (productForm) {
        productForm.addEventListener('cart-updated', (evt) => {
          this.closeQuickshop();
        });
      }
    }

    openQuickshop() {
      this.classList.add('quick-shop--is-open');
      if (this.options.popup) {
        // Open this quickshop
        var content = this.querySelector('[data-quickshop-content]');
        this.fancybox = new R([
          {
            src: content,
            type: 'inline',
            dragToClose: false,
            closeButton: false,
          },
        ]);
      } else {
        // Show the inline backdrop
        this.backdrop.classList.add('backdrop--active');
      }
    }

    closeQuickshop() {
      this.classList.remove('quick-shop--is-open');

      // Close all fancyboxes
      R.close();

      // Close the inline backdrop
      this.backdrop.classList.remove('backdrop--active');
    }
  }

  window.QuickShopWrapper = QuickShopWrapper;
  customElements.define('quickshop-wrapper', QuickShopWrapper);
}

/**
 * Open or close the quickshop
 */
class QuickShopToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      // when clicked inside a popup, find the opened quickshop and close it
      if (this.closest('.fancybox__container')) {
        document
          .querySelectorAll('quickshop-wrapper.quick-shop--is-open')
          .forEach((quickshopWrapper) => {
            quickshopWrapper.closeQuickshop();
          });
      } else {
        // Dispatch an event to toggle the quickshop
        this.dispatchEvent(
          new CustomEvent('quickshop-toggle', {
            bubbles: true,
          })
        );
      }
    });
  }
}

if (!customElements.get('quickshop-toggle')) {
  customElements.define('quickshop-toggle', QuickShopToggle);
}
